import React from 'react';

import Nl2br from '../Nl2br';
import VirtualizedList from '../VirtualizedList';
import styled from 'styled-components';
import AnswerComment from './AnswerComment';
import WidgetHeader from '../WidgetHeader';

function TextWidget({id, answers, sheetsById, question, options}) {

  //Remove this filter once functionality is added to pin TextWidget
  let filteredOptions = options.filter(option => option.title !== "Pin");

  return (
    <React.Fragment>
      <WidgetHeader id={id} title={question.text} options={filteredOptions}/>
      <ScrollContent>
        <VirtualizedList items={answers.filter(answer => !!answer.value)} defaultHeight={85}>
          {answer => {
            const sheet = sheetsById[answer.sheetId];

            return (
              <AnswerComment sheet={sheet} answer={answer}>
                <Nl2br>{answer.value}</Nl2br>
              </AnswerComment>
            );
          }}
        </VirtualizedList>
      </ScrollContent>
    </React.Fragment>
  );
}

const ScrollContent = styled.div`
  height: 39.125rem;
`;

export default React.memo(TextWidget);
